import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import useRouter from 'hooks/use-router'

function useRedirect() {
  const { push } = useRouter()
  const location = useLocation()
  const [url, setUrl] = useState('')

  useEffect(() => {
    const urlRedirect = localStorage.getItem('internal_redirect')
    if (urlRedirect) {
      setUrl(urlRedirect)
    }
  }, [])

  const redirect = () => {
    if (url) {
      push(url)
    }
  }

  const setRedirect = (url: string) => {
    // console.log('URL recibida:', url)

    if (!url.includes('xeerpa-manager') && !url.includes('login-manager')) {
      const currentHash = location.hash

      // console.log('Parámetros actuales:', searchParams)
      // console.log('Hash actual:', currentHash)

      const fullUrl = `${url}${currentHash}`
      // console.log('URL final con utms y hash:', fullUrl)

      localStorage.setItem('internal_redirect', fullUrl)
      setUrl(fullUrl)
    }
  }

  const clearRedirect = () => {
    localStorage.removeItem('internal_redirect')
    setUrl('')
  }

  const getRedirectLocal = () => {
    return localStorage.getItem('internal_redirect')
  }

  const redirectByLocal = () => {
    const urlRedirect = localStorage.getItem('internal_redirect')
    if (urlRedirect) {
      push(urlRedirect)
    }
  }

  return [{ url }, { redirect, setRedirect, clearRedirect, redirectByLocal, getRedirectLocal }]
}

export default useRedirect
